<template>
    <div class="status-panel">
      <div class="is-flex">
        <div class="is-flex flex-align--center grow">
          <div class="icon-color icon-background-color">
            <font-awesome-icon size="3x" :icon="['fas', 'code-merge']"/>
          </div>
          <div class="is-flex flex-align--center">
            <div class="status-panel--header" role="heading" aria-level="1">
              RETIRED RECORD:
            </div>
            <div class="subtext-font-size border">
              This record has been retired and cannot be edited or recovered.
            </div>
          </div>
        </div>
        <div v-if="person.personId !== null" class="is-flex flex-align--center border">
          <div class="is-flex flex-direction--column">
            <div class="state-id">
              {{ formatStateID(person.personId) }}
            </div>
            <div class="subtext-state-id">
              {{ fieldLabel('STATE_STUDENT_ID') }} Retired
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>

<script>
import { mapGetters } from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faCodeMerge,
} from '@fortawesome/pro-solid-svg-icons';
import StateIdUtils from '@/mixins/StateIdUtils';

library.add(
  faCodeMerge,
);

export default {
  mixins: [
    StateIdUtils,
  ],
  props: {
    person: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      activeModule: 'appModules/getActiveModule',
    }),
    ...mapGetters('fieldLabelsModule', [
      'getFieldLabelByPersonType',
    ]),
  },
  methods: {
    fieldLabel(code) {
      return this.getFieldLabelByPersonType(code, this.activeModule.spec, this.person.personType);
    },
  },
};
</script>

  <style lang="sass" scoped>
    .border
      border-left: 1px solid #dee2e6!important
    .status-panel
      border: 1px solid #bbb
      background-color: #FFFFFF
      box-shadow: 0 0 3px #aaa
      margin-bottom: 1rem
    .flex-align--center
      gap: 0.5rem
    .status-panel--header
      font-size: 20px
      font-weight: 700
      padding-left: 1rem
    .subtext-font-size
      color: #757575
      font-size: 13.6px
      font-weight: 700
      padding-left: 1rem
    .subtext-state-id
      color: #737373
      font-size: 12px
      font-weight: 400
      padding: 0 1rem
    .state-id
      color: #000000
      font-size: 16px
      font-weight: 700
    .icon-color
      color: #FFFFFF
      padding: 1rem
      font-size: 12px
    .icon-background-color
      background-color: #FFC107
  </style>
